import {
  getItemV1Data,
} from 'services/itemV1';

export async function getItemDataV1Data({ siteRef, itemRef }) {
  let response = '';
  let errorMessage = '';  
  try {
    response = await getItemV1Data({
      url: `/sites/${siteRef}/items/${itemRef}`,
      withAuth: true,
    });
  } catch (error) {
    if (error.apiStatusCode === '404') {
      errorMessage = 'Item Details Not Found';
    } else {
      errorMessage = error.message;
    }
  }
  return { response, errorMessage };
}

export async function getItemDescriptionV1Data({ reqParams = {} }) {
  let response = '';
  let errorMessage = '';  
  try {
    response = await getItemV1Data({
      apiConfig: {
        params: reqParams,
      },
      url: `/itemdescription`,
      withAuth: true,
    });
  } catch (error) {
    if (error.apiStatusCode === '404') {
      errorMessage = 'Item Details Not Found';
    } else {
      errorMessage = error.message;
    }
  }
  return { response, errorMessage };
}
